module.exports = __webpack_public_path__ + "img/solo.app@2x.3a4fdc23.png";